<template>
  <Modal v-model="taxRateSettingModal" :title="taxRateSettingTitle" width="500"
    :transfer="false" :mask-closable="false" @on-visible-change="taxRateSettingChange">
    <Form ref="taxRateSettingForm" :model="taxRateSettingForm" :rules="ruleValidate" :label-width="labelWidth">
      <Row style="width: 80%" @submit.native.prevent>
        <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
          <Form-item :label="$t('key1002493')" prop="countryCode">
            <Select v-model="taxRateSettingForm.countryCode" transfer filterable :disabled="taxRateSettingType === 'edit'">
              <Option v-for="(item, index) in newCountrysData" :value="item.twoCode" :key="index">{{ item.cnName }}</Option>
            </Select>
          </Form-item>
        </Col>
        <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
          <Form-item :label="$t('key1002494')" prop="rate">
            <Input clearable v-model.trim="taxRateSettingForm.rate" :placeholder="$t('key1000324')">
              <span slot="append">%</span>
            </Input>
          </Form-item>
        </Col>
      </Row>
    </Form>
    <template #footer>
      <Button @click="taxRateSettingModal = false">{{ $t('key1000112') }}</Button>
      <Button type="primary" @click="taxRateSettingBtn">{{ $t('key1000555') }}</Button>
    </template>
  </Modal>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import api from '@/api/';
import Mixin from "@/components/mixin/common_mixin";

export default {
  name: "taxRateSettingModal",
  mixins: [Mixin],
  props: {
    countrysOriginalData: {
      type: Array,
      default: () => []
    },
    originalData: {
      type: Array,
      default: () => []
    }
  },
  data() {
    let v = this;
    return {
      taxRateSettingModal: false,
      taxRateSettingTitle: '',
      taxRateSettingForm: {
        countryCode: null,
        rate: ''
      },
      ruleValidate: {
        countryCode: [
          {required: true, message: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002487'), trigger: 'change'}
        ],
        rate: [
          {required: true, message: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002488'), trigger: 'blur'},
          {pattern: v.$regular.twoDecimalPlaces, message: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002489'), trigger: 'blur'}
        ],
      },
      taxRateSettingType: 'add',
      ymsIossRateSettingId: null,
      newCountrysData: []
    };
  },
  methods: {
    // 初始化数据
    initTaxRateSettingData(type, originalData, data) {
      this.taxRateSettingType = type;
      let obj = {
        add: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002490'),
        edit: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002491')
      };
      this.taxRateSettingTitle = obj[type];
      if (type === 'edit') {
        this.newCountrysData = this.countrysOriginalData;
        this.ymsIossRateSettingId = data.ymsIossRateSettingId;
        this.taxRateSettingForm.countryCode = data.countryCode;
        let rateVal = (data.rate * 100).toFixed(2);
        this.taxRateSettingForm.rate = rateVal.toString();
      } else {
        this.handleCountrysData(originalData);
      }
      this.taxRateSettingModal = true;
    },
    // 处理国家的基础数据
    handleCountrysData(originalData) {
      this.newCountrysData = [];
      let arr = [];
      let keyList = originalData.map((item) => {
        return item.countryCode;
      });
      this.countrysOriginalData.map((item) => {
        if (!keyList.includes(item.twoCode)) {
          arr.push(item);
        }
      });
      this.newCountrysData = this.uniqueFunc(arr, 'twoCode');
    },
    // 保存
    taxRateSettingBtn() {
      let v = this;
      let url = '';
      let method = '';
      let text = '';
      let query = Object.assign({}, v.taxRateSettingForm);
      if (v.taxRateSettingType === 'add') {
        url = api.post_ymsIossRateSetting_insert;
        method = 'post';
        text = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000194');
      } else if (v.taxRateSettingType === 'edit') {
        url = api.put_ymsIossRateSetting_update;
        method = 'put';
        text = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002279');
        query.ymsIossRateSettingId = v.ymsIossRateSettingId;
      }
      v.$refs['taxRateSettingForm'].validate((valid) => {
        if (valid) {
          query.rate = (v.taxRateSettingForm.rate / 100).toFixed(2);
          v.axios[method](url, query, {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then(response => {
            if (response.data.code === 0) {
              v.taxRateSettingModal = false;
              v.$Message.success(text);
              v.$emit('updateData', true);
            }
          });
        }
      });
    },
    // 监听弹窗
    taxRateSettingChange(val) {
      if (!val) {
        this.$refs['taxRateSettingForm'].resetFields();
      }
    },
    // 校验清关费率
    validateRate() {
      let v = this;
      let twoDecimalPlaces = v.$regular.twoDecimalPlaces;
      return function (rule, value, callback) {
        if (!value) {
          callback(new Error(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002492')));
        } else if (!twoDecimalPlaces.test(value)) {
          callback(new Error(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002489')));
        }
        callback();
      };
    }
  }
};
</script>

<style lang="less" scoped>

</style>